export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6432.4dd0bcea.jpg";